import { render, staticRenderFns } from "./BrandButtonGroup.vue?vue&type=template&id=4b52ad6c&scoped=true&"
import script from "./BrandButtonGroup.vue?vue&type=script&lang=js&"
export * from "./BrandButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./BrandButtonGroup.vue?vue&type=style&index=0&id=4b52ad6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52ad6c",
  null
  
)

export default component.exports